import SrtDownloadPlaceholder from '@/shared/assets/images/srt-download.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { BoosterType } from '@/shared/types/Billing';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock .SRT download',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'srtUploadDownload',
    'voiceCloneSettings',
    'voicePresets',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    src: SrtDownloadPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeSrtDownloadModalClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeSrtDownloadModalShown,
  subtitle:
    'Upgrade to Creator Pro plan to download SRT files containing subtitles for both the original and translated videos',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
  booster: BoosterType.SRT,
  buttonText: 'or Upgrade to Creator Pro',
  content: {
    chip: {
      title: 'Get full control over your subtitles with SRT and Pro tools',
    },
    learnMore: {
      title: 'Learn more',
      link: 'https://help.rask.ai/hc/what-is-srt-download-rask-help-center',
      text: 'about SRT Download',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'creators who need custom subtitle variations, YouTube uploads, or external editing workflows.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: "What you'll get",
      bullets: [
        'Plain-text subtitle files with timecodes and spoken text',
        'Both original and translated subtitle versions with speakers',
        'Text segments formatted for video platforms or editing tools',
      ],
    },
  },
  features: [],
  media: {
    ...BASE_CONTENT.media,
  },
  subtitle: 'Get flexible subtitle files you can edit, customize, and use anywhere.',
};

export const SRT_DOWNLOAD_CONTENT: LimitedFeatureContent = {
  creator: TRIAL_PLAN_CONTENT,
  starter: TRIAL_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
